import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import { FaCog, FaEdit, FaEye, FaTrashAlt, FaMoneyBillWave } from "react-icons/fa";
// import Dropdown from "../../../components/AdminDropdown/Dropdown";
import axios from "axios";
import Select from "react-select";
import { RxCross1 } from "react-icons/rx";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import { languageHelper } from "../../../config/helperFunctions";

function Expenses() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Date") || "Date",
      accessorKey: "date",
    },
    {
      header: languageHelper("Amount") || "Amount",
      accessorKey: "amount",
    },
    {
      header: languageHelper("Vat Percentage") || "Vat Percentage",
      accessorKey: "vat_percentage",
    },
    {
      header: languageHelper("Vat") || "Vat",
      accessorKey: "vat",
    },

    {
      header: languageHelper("Tax Method") || "Tax Method",
      accessorKey: "tax_method",
    },
    {
      header: languageHelper("Category") || "Category",
      // accessorKey: "Category",
      cell: (row) => row.row.original.category?.name,
    },
    {
      header: languageHelper("Payment Method") || "Payment Method",
      // accessorKey: "Paymentmethod",
      cell: (row) => row.row.original.payment_method?.name,
    },
    {
      header: languageHelper("Supplier") || "Supplier",
      // accessorKey: "Paymentmethod",
      cell: (row) => row.row.original.supplier?.name,
    },
    {
      header: languageHelper("Responsible Person") || "Responsible Person",
      // accessorKey: "ResponsiblePerson",
      cell: (row) => row.row.original.employee?.name,
    },
    {
      header: languageHelper("Note") || "Note",
      accessorKey: "note",
    },
    {
      header: languageHelper("Paid") || "Paid",
      cell: (row) =>
        row.row.original.supplier_id ? row.row.original.paid : "-",
    },
    {
      header: languageHelper("Due") || "Due",
      cell: (row) =>
        row.row.original.supplier_id ? row.row.original.due : "-",
    },

    {
      header: languageHelper("Actions") || "Actions",
      accessorKey: "total",
      cell: (row) => (
        <ActionDropdown
          expense={row.row.original}
          user={user}
          refetchData={fetchData}
          onAddPayment={handleDuePayment}
        />
      ),
    },
  ];
  const [data, setData] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [paymentData, setPaymentData] = useState({
    date: new Date().toISOString().split("T")[0],
    amount: "",
    payment_method_id: "",
    note: "",
  });
  const buttonData = [
    {
      buttonText: languageHelper("Add Expenses") || "Add Expenses",
      path: "addExpenseForm",
    },
  ];

  const handleDuePayment = (expense) => {
    setSelectedExpense(expense);
    setPaymentData({
      date: new Date().toISOString().split("T")[0],
      amount: expense.due,
      payment_method_id: "",
      note: "",
    });
    setShowPaymentModal(true);
  };

  const handlePaymentChange = (e) => {
    setPaymentData({ ...paymentData, [e.target.name]: e.target.value });
  };

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    const amount = parseFloat(paymentData.amount);
    const due = parseFloat(selectedExpense?.due || 0);

    if (!amount || amount <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }
    if (amount > due) {
      toast.error(`Amount cannot exceed the due amount (${due})`);
      return;
    }
    if (!paymentData.payment_method_id) {
      toast.error("Please select a payment method");
      return;
    }

    axios
      .put(
        `${apiKey}/api/rms/admin/expense-payment/${selectedExpense.id}`,
        paymentData,
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.message || "Payment added successfully", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setShowPaymentModal(false);
        fetchData();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error occurred", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/expense`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id
        }
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    fetchData();
    axios
      .get(`${apiKey}/api/rms/admin/get-all-payment`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setPaymentMethods(
          res.data.map((method, index) => ({
            label: method.name,
            value: method.id,
            index,
          }))
        );
      })
      .catch((err) => {
        console.log("Cannot load payment methods");
      });
  }, [fetchData, user?.token]);
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        error={error}
        heading={languageHelper("Expenses") || "Expenses"}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}

      {showPaymentModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
          <div className="fixed inset-0 bg-black opacity-50"></div>
          <div className="relative w-full max-w-lg mx-auto my-6 z-50">
            <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
              <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-blueGray-200">
                <h3 className="text-2xl font-semibold">
                  {languageHelper("Add Payment")}
                </h3>
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setShowPaymentModal(false)}
                >
                  <RxCross1 />
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <form onSubmit={handlePaymentSubmit}>
                  <div className="grid grid-cols-1 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {languageHelper("Date")}
                      </label>
                      <input
                        type="date"
                        name="date"
                        value={paymentData.date}
                        onChange={handlePaymentChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-d-bg focus:border-d-bg sm:text-sm"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {languageHelper("Amount")}
                      </label>
                      <input
                        type="number"
                        name="amount"
                        value={paymentData.amount}
                        onChange={handlePaymentChange}
                        step="0.01"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-d-bg focus:border-d-bg sm:text-sm"
                        required
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        {languageHelper("Due Amount")}: {selectedExpense?.due}
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {languageHelper("Payment Method")}
                      </label>
                      <Select
                        type="text"
                        placeholder={languageHelper("Select")}
                        className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                        required
                        options={paymentMethods}
                        onChange={(e) =>
                          setPaymentData({
                            ...paymentData,
                            payment_method_id: e.value,
                          })
                        }
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {languageHelper("Note")}
                      </label>
                      <textarea
                        name="note"
                        value={paymentData.note}
                        onChange={handlePaymentChange}
                        rows="3"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-d-bg focus:border-d-bg sm:text-sm"
                      ></textarea>
                    </div>
                  </div>
                  <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">
                    <button
                      className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowPaymentModal(false)}
                    >
                      {languageHelper("Close")}
                    </button>
                    <button
                      className="bg-d-bg text-white active:bg-d-bg font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="submit"
                    >
                      {languageHelper("Submit")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

function ActionDropdown({ expense, user, refetchData, onAddPayment }) {
  const id = expense.id;
  const [showDropdown, setShowDropDown] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const handleDelete = () => {
    axios
      .delete(`${apiKey}/api/rms/admin/expense/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        refetchData();
        setShowDelModal(false);
        setShowDropDown(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  return (
    <>
      <div className="relative">
        <button
          className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
          onClick={() => setShowDropDown(!showDropdown)}
        >
          <FaCog className="text-d-bg-text" />
          <IoIosArrowDown className="text-d-bg-text" />
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-10 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
          }
        >
          <Link
            to={`addExpenseForm/${id}`}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaEdit />
            <p> {languageHelper("Edit")} </p>
          </Link>
          <Link
            to={`expenseDetails/${id}`}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaEye />
            <p> {languageHelper("View Details")} </p>
          </Link>
          <button
            onClick={() => setShowDelModal(true)}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaTrashAlt />
            <p> {languageHelper("Delete")} </p>
          </button>
          {expense.supplier_id && parseFloat(expense.due) > 0 && (
            <button
              onClick={() => {
                onAddPayment(expense);
                setShowDropDown(false);
              }}
              className={
                "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
              }
            >
              <FaMoneyBillWave />
              <p> {languageHelper("Add Payment")} </p>
            </button>
          )}
        </div>
      </div>

      {showDelModal && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
          onClick={() => setShowDelModal(false)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-d-bg-text font-semibold text-xl text-center">
                {languageHelper("Alert!")}
              </h1>
              <p className="text-center text-gray-700">{languageHelper("Are you sure?")}</p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setShowDelModal(false)}
              >
                {languageHelper("No")}
              </button>
              <button
                onClick={handleDelete}
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                {languageHelper("Yes")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Expenses;
